module.exports = __webpack_public_path__ + "static/media/complaints.9a895f83.svg";